import React from 'react';
import RegistrationForm from '@payments/organisms/forms/registration';
import { SubscriptionFormProps } from '@payments/types';

const Register: React.FC<SubscriptionFormProps> = (props) => {
  return (
    <div className="u-margin-T-l">
      <RegistrationForm {...props} />
    </div>
  );
};

export default Register;


